import script from "./Center.vue?vue&type=script&setup=true&lang=js"
export * from "./Center.vue?vue&type=script&setup=true&lang=js"

import "./Center.vue?vue&type=style&index=0&id=1c366430&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c366430"]])

export default __exports__